// 界桩
<template>
  <div class="boundaryMsgPage">
    <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    >
    <div v-if="!showNonePage">
      <van-cell-group class="forestInput">
        <van-field
          v-model="baseData.typeName"
          readonly
          :label="$t('common.type') + '：'"
        />
        <van-field
          :value="baseData.regionName"
          readonly
          :label="$t('common.politicalTit') + '：'"
        />
        <!-- 海拔 -->
        <van-field
          :value="baseData.altitude+$t('common.meter')"
          readonly
          :label="$t('common.altitudeName') + '：'"
        />
        <!-- 保护区名称 -->
        <van-field
          :value="baseData.areaName"
          readonly
          :label="$t('common.areaName') + '：'"
        />
        <!-- 标号 -->
        <van-field
          :value="baseData.pillarCode"
          readonly
          :label="$t('common.pillarCode') + '：'"
        />
        <!-- 经度 -->
        <van-field
          :value="baseData.lon"
          readonly
          :label="$t('common.longitude') + '：'"
        />
        <!-- 纬度 -->
        <van-field
          :value="baseData.lat"
          readonly
          :label="$t('common.latitude') + '：'"
        />
        <!-- 说明 -->
        <van-field
          :value="baseData.remark"
          rows="3"
          autosize
          type="textarea"
          readonly
          :label="$t('common.explainTit') + '：'"
        />
      </van-cell-group>
      <p class="fgx"></p>
    </div>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
const refreshPage = () => import("@/components/common/refreshPage");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "boundaryMsg",
  data() {
    return {
      showNonePage: true,
      boundaryId: "", //界桩Id
      baseData: {},
      refreshPage: false, //网络失败
      clientType: "", //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    document.title = "界桩信息";
    this.clientType = getDeviceType();
    console.log(this.param,'this.param')
    this.$nextTick(function () {
      this.boundaryId = this.$route.query.commonId;
      if (this.boundaryId == undefined) {
        this.boundaryId = this.param.id;
      }
      this.initPage();
    });
  },
  components: {
    refreshPage,
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.universal
        .boundary.boundaryDetaisl(_this.boundaryId)
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.showNonePage = false;
            _this.baseData = Object.assign({}, _this.baseData, res.data);
            if (_this.baseData.imgs == []) {
              _this.baseData.imgs = "";
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
  },
  watch: {
    param: {
      handler: function () {
        let _this = this;
        _this.billboardId = _this.param.id;

        _this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.boundaryMsgPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;

  .forestInput {
    .van-cell {
      .van-field__label {
        color: #999;
        font-size: 14px;
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }

      .van-cell__title {
        width: 120px;
      }
    }

    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }

  .fgx {
    width: 100%;
    height: 20px;
    background-color: #f6f6f6;
  }

  .description {
    background-color: #fff;
    border-top: 1px solid #ebedf0;
    border-bottom: 1px solid #ebedf0;
    padding: 10px 16px 20px 16px;

    h4 {
      font-size: 14px;
      color: #666;
    }

    p.desMain {
      margin-top: 10px;
      font-size: 12px;
      color: #666;

      img {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        display: block;
      }
    }
  }
}
</style>